import ESGConverterPage from "components/esg/ESGConverterPage";

const ESGConverterEmbedPage = () => <ESGConverterPage embed />;

export default ESGConverterEmbedPage;
